export default "__VITE_ASSET__JzMhJ$$O__"